const API_URL = process.env.REACT_APP_PROD_URL

const variables = {
  API_URL,
};

export default variables;
